export default "__VITE_PUBLIC_ASSET__2feb8993__"